var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.583008L12.5423 3.79134V10.208L7.00065 13.4163L1.45898 10.208V3.79134L7.00065 0.583008ZM7.00065 1.93109L2.62565 4.46392V9.53542L7.00065 12.0683L11.3757 9.53542V4.46392L7.00065 1.93109ZM7.00065 9.33301C6.38181 9.33301 5.78832 9.08718 5.35073 8.64959C4.91315 8.21201 4.66732 7.61851 4.66732 6.99967C4.66732 6.38084 4.91315 5.78734 5.35073 5.34976C5.78832 4.91217 6.38181 4.66634 7.00065 4.66634C7.61949 4.66634 8.21298 4.91217 8.65057 5.34976C9.08815 5.78734 9.33398 6.38084 9.33398 6.99967C9.33398 7.61851 9.08815 8.21201 8.65057 8.64959C8.21298 9.08718 7.61949 9.33301 7.00065 9.33301ZM7.00065 8.16634C7.31007 8.16634 7.60682 8.04342 7.82561 7.82463C8.0444 7.60584 8.16732 7.30909 8.16732 6.99967C8.16732 6.69026 8.0444 6.39351 7.82561 6.17472C7.60682 5.95592 7.31007 5.83301 7.00065 5.83301C6.69123 5.83301 6.39449 5.95592 6.17569 6.17472C5.9569 6.39351 5.83398 6.69026 5.83398 6.99967C5.83398 7.30909 5.9569 7.60584 6.17569 7.82463C6.39449 8.04342 6.69123 8.16634 7.00065 8.16634Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e19529e356700598b2710a8c0984da60.svg";
export { ForwardRef as ReactComponent };